import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask600To699Service {

  constructor() { }
}
